// extracted by mini-css-extract-plugin
module.exports = {"animated-ellipsis":"Ellipsis_animated-ellipsis__90U8m","one":"Ellipsis_one__1Z0c1","dot":"Ellipsis_dot__2Hkdd","two":"Ellipsis_two__2hVFL","three":"Ellipsis_three__Xu_iv"};